"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetScenarioType = exports.BudgetSiSClassification = exports.BudgetVersionType = void 0;
var BudgetVersionType;
(function (BudgetVersionType) {
    BudgetVersionType["DRAFT"] = "draft";
    BudgetVersionType["SNAPSHOT"] = "snapshot";
})(BudgetVersionType || (exports.BudgetVersionType = BudgetVersionType = {}));
var BudgetSiSClassification;
(function (BudgetSiSClassification) {
    BudgetSiSClassification["SERVICE"] = "Service";
    BudgetSiSClassification["SALES"] = "Sales";
    BudgetSiSClassification["SIS"] = "SiS";
    BudgetSiSClassification["RETAIN"] = "Retain";
})(BudgetSiSClassification || (exports.BudgetSiSClassification = BudgetSiSClassification = {}));
// CALL-762: What-if scenario types shown in the board's "Art" column. Stored as strings.
// reachability_adjustment covers the "Erreichbarkeit Anpassung" / GA-CB-VVL driver scenario.
var BudgetScenarioType;
(function (BudgetScenarioType) {
    BudgetScenarioType["CONTACTS"] = "contacts";
    BudgetScenarioType["MINUTE_PRICE"] = "minute_price";
    BudgetScenarioType["SHIFT"] = "shift";
    BudgetScenarioType["BUDGET_ADJUSTMENT"] = "budget_adjustment";
    BudgetScenarioType["REACHABILITY_ADJUSTMENT"] = "reachability_adjustment";
})(BudgetScenarioType || (exports.BudgetScenarioType = BudgetScenarioType = {}));
